import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useApi } from "../../../../hooks/useApi"
import { ShortLocateListResponse } from "../types/common"

const SHORT_LOCATES_QUERY_KEY = "short-locates"

const useGetShortLocates = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { scientApi } = useApi()
  const queryClient = useQueryClient()

  const { data, isLoading, isError, error } = useQuery<ShortLocateListResponse>({
    queryKey: [SHORT_LOCATES_QUERY_KEY],
    queryFn: () => scientApi.trading.getShortLocates(),
    enabled,
  })

  const refreshLocates = async () => {
    await queryClient.invalidateQueries({ queryKey: [SHORT_LOCATES_QUERY_KEY] })
  }

  return {
    locates: data?.data || [],
    isLoading,
    isError,
    error,
    refreshLocates,
  }
}

export default useGetShortLocates
